module.exports = __webpack_public_path__ + "static/media/painting5.e8052801.jpg";